<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useAlert } from 'dashboard/composables';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  pipeline: {
    type: Object,
    required: true,
  },
});

const store = useStore();
const router = useRouter();

const confirmText = ref('');
const isDeleting = ref(false);

const canDelete = computed(() => {
  return confirmText.value === props.pipeline.name;
});

const handleDelete = async () => {
  if (!canDelete.value) return;

  isDeleting.value = true;
  try {
    await store.dispatch('pipelines/delete', {
      accountId: store.getters.getCurrentAccountId,
      pipelineId: props.pipeline.id,
    });

    useAlert('Pipeline excluido com sucesso!');

    router.push(
      `/app/accounts/${store.getters.getCurrentAccountId}/pipelines`
    );
  } catch (error) {
    useAlert('Erro ao excluir pipeline');
  } finally {
    isDeleting.value = false;
  }
};
</script>

<template>
  <div class="space-y-6">
    <div>
      <h3 class="text-lg font-bold text-n-ruby-9 mb-1">
        Excluir Pipeline
      </h3>
      <p class="text-sm text-n-slate-11">
        Esta acao nao pode ser desfeita. Todos os negocios e estagios serao
        excluidos permanentemente.
      </p>
    </div>

    <div
      class="max-w-2xl p-4 border-2 border-n-ruby-6 bg-n-ruby-2 rounded-lg"
    >
      <p class="text-sm text-n-ruby-11 mb-4">
        <strong>Atencao:</strong> Depois de excluir um pipeline, nao ha como
        voltar atras. Todos os negocios e estagios serao excluidos
        permanentemente.
      </p>

      <div class="space-y-4">
        <label class="block">
          <span class="block text-sm font-medium text-n-slate-12 mb-1.5">
            Digite <strong>"{{ pipeline.name }}"</strong> para confirmar:
          </span>
          <input
            v-model="confirmText"
            type="text"
            placeholder="Digite o nome do pipeline"
            class="w-full px-3 py-2.5 text-sm border border-n-weak rounded-lg bg-n-surface-1 hover:border-n-slate-6 focus:outline-none focus:border-n-brand transition-colors"
          />
        </label>

        <Button
          variant="solid"
          color="ruby"
          icon="i-lucide-trash-2"
          :disabled="!canDelete || isDeleting"
          :is-loading="isDeleting"
          @click="handleDelete"
        >
          Excluir Pipeline Permanentemente
        </Button>
      </div>
    </div>
  </div>
</template>
